import {
  Dialog,
  DialogMaxWidth,
  DialogVariant,
  Grid,
  Text,
  TextHighlight,
  TextSize
} from '@focaldata/cin-ui-components'

interface Props {
  open: boolean
  /** Market display label of the market being made base (e.g. "United Kingdom"). */
  marketName?: string
  /** True while the set-base mutation is in flight. */
  busy: boolean
  onConfirm: () => void
  onClose: () => void
}

/**
 * Confirmation shown before the project's base market is changed. Global custom
 * audience questions are owned by the base market, so re-basing moves their
 * owner/editor to the newly selected market and re-propagates them across the
 * project — hence an explicit confirm. Mirrors RemoveMarketDialog so both
 * consequential market actions share the same styled-dialog pattern (and neither
 * uses a native window.confirm).
 */
const ChangeBaseMarketDialog = ({
  open,
  marketName,
  busy,
  onConfirm,
  onClose
}: Props) => (
  <Dialog
    open={open}
    // Don't let a click-outside dismiss mid-update.
    onClose={busy ? () => undefined : onClose}
    title={
      marketName
        ? `Make ${marketName} the base market?`
        : 'Change the base market?'
    }
    variant={DialogVariant.DoubleButton}
    maxWidth={DialogMaxWidth.Sm}
    primaryButtonText={busy ? 'Updating…' : 'Change base market'}
    primaryButtonClick={onConfirm}
    primaryButtonDisabled={busy}
    primaryButtonLoading={busy}
    secondaryButtonText="Cancel"
    secondaryButtonClick={onClose}
    secondaryButtonDisabled={busy}
  >
    <Grid container direction="column" spacing={1} style={{ padding: 16 }}>
      <Grid item>
        <Text size={TextSize.ml} highlight={TextHighlight.Background}>
          Global custom audience questions are owned by the base market. The
          newly selected market will become their owner/editor, and they will be
          re-propagated to the other markets.
        </Text>
      </Grid>
    </Grid>
  </Dialog>
)

export default ChangeBaseMarketDialog
